import React from 'react';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import axios from 'axios';
import Alert from "react-bootstrap/Alert";
import Row from "react-bootstrap/Row";
import Input from "./Input";
import {match, min_length, required} from "../Validation";

const validator = {
    email: [required(), match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)],
    password: [required(), min_length(4)]

};

export default class LoginForm extends React.Component {
    state = {
        values: {
            email: '',
            password: '',
        },
        errors: {
            form: '',
            email: '',
            password: '',
        },
        isSubmitting: false,
    };

    constructor(props) {
        super(props);
        this.jwtClient = props.JwtClient;
        this.storage = props.Storage;
    }


    render() {
        const {
            values,
            errors,
            isSubmitting
        } = this.state;
        return (
            <Container>
                <Row>
                    <div className="col-4 offset-4 mt-5">
                        <Form onSubmit={this.handleSubmit}>
                            <Alert variant="danger" show={!!errors.form}>{errors.form}</Alert>
                            <Form.Group>
                                <Input
                                    name="email"
                                    prependIcon="at"
                                    type="email"
                                    value={values.email}
                                    error={errors.email}
                                    onChange={this.handleChange}
                                    onBlur={(e) => {
                                        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                        const email = e.target.value;
                                        if (email === '') {
                                            this.setErrors({email: 'Required'});
                                        } else if (!re.test(email.toLowerCase())) {
                                            this.setErrors({email: 'Invalid'});
                                        }
                                    }}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Input
                                    name="password"
                                    prependIcon="lock"
                                    type="password"
                                    value={values.password}
                                    error={errors.password}
                                    onChange={this.handleChange}
                                    onBlur={(e) => {
                                        const password = e.target.value;
                                        if (password === '') {
                                            this.setErrors({password: 'Required'});
                                        } else if (password.length < 4) {
                                            this.setErrors({password: 'Min 4 characters are allowed'})
                                        }
                                    }}
                                />
                            </Form.Group>
                            <div className="text-right">
                                <Button type="submit" disabled={isSubmitting} className="btn-success">Sign
                                    in</Button>
                            </div>
                        </Form>
                    </div>
                </Row>
            </Container>
        )
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const {
            values,
            errors,
        } = this.state;
        if ((errors.email || errors.password) || (!values.email || !values.password)) {
            this.setErrors({form: 'Invalid email or password'});
            return;
        }
        this.setSubmitting(true);
        axios.post('/api/v1/token', values)
            .then((response) => {
                this.storage.saveJwtResponseData(response.data);
            })
            .catch((error) => {
                // TODO send error to server
                if (error.response.status === 400) {
                    this.setErrors({form: 'Invalid email or password'});
                } else if (error.response.status === 403) {
                    this.setErrors({form: 'Forbidden, please contact administrator'});
                } else if (error.response.status === 500) {
                    this.setErrors({form: 'Server error'});
                } else {
                    alert(error);
                }
                this.setSubmitting(false);
            })
            .then(() => {
                if (!this.storage.getIsStaff() && this.storage.getEmail()) {
                    this.loadClientInfo('/api/v1/client');
                }
                // TODO add message for staff, now it just hangs without redirect
            });
    };

    loadClientInfo = url => {
        this.jwtClient.get(url)
            .then(response => {
                this.storage.saveClientInfo(response.data);
                window.location.replace('/');
            })
            .catch(error => {
                if (error.response.status === 401) {
                    this.logout();
                }
                this.setErrors({form: 'The service has responded with an error! Contact the administrators to resolve the issue!'});
            })
    };

    handleChange = (e) => {
        this.setValues({[e.target.name]: e.target.value});
        this.delErrors();
    };

    setValues = (values) => {
        this.setState({values: {...this.state.values, ...values}});
    };

    setErrors = (errors) => {
        this.setState({errors: {...this.state.errors, ...errors}});
    };

    delErrors = () => {
        let errors = {};
        for (let key of Object.keys(this.state.errors)) {
            errors[key] = '';
        }
        this.setErrors(errors);
    };

    setSubmitting = (isSubmitting) => {
        this.setState({isSubmitting: isSubmitting});
    };

}